/**
 * 生产随机数
 */
export default function getNanoId() {
  const urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
  let id = '';
  let i = 30;
  while (i--) {
    // eslint-disable-next-line no-bitwise
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return `${id}-${new Date().getTime()}`;
}
